import { Search } from 'components/icons/Search'
import type { ForwardedRef } from 'react'
import { forwardRef } from 'react'
import type { BreakoutInputProps } from './BreakoutTextInput'
import { BreakoutTextInput } from './BreakoutTextInput'
import classNames from 'classnames'

// A convenience component for the BreakoutTextInput that is preconfigured for search input
export const BreakoutSearchInput = forwardRef(function BreakoutSearchInput(
  {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ref: _ignored,
    disabled,
    ...rest
  }: Omit<BreakoutInputProps, 'LeadingIcon'>,
  ref: ForwardedRef<HTMLInputElement>
) {
  return (
    <BreakoutTextInput
      inputClassName={classNames(
        '!text-body-medium outline-outline-variant !h-10',
        !disabled && 'placeholder:text-on-surface-var',
        disabled && 'placeholder:text-on-surface-disabled',
        rest.inputClassName
      )}
      iconClassName={classNames(
        '!left-4',
        'stroke-on-surface-var',
        rest.iconClassName
      )}
      kind={rest.kind ?? 'tertiary'}
      LeadingIcon={Search}
      ref={ref}
      iconSize={rest.iconSize ?? 15}
      allowClear={rest.allowClear ?? true}
      {...rest}
    />
  )
})
